module.exports = __webpack_public_path__ + "static/media/aaapv.4cd6f628.svg";